import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import React from 'react';
import { logout } from '@kineticdata/react';
import { LoginForm } from './LoginForm';

export const LoginDialog = props => (
  <Modal isOpen={props.isOpen} toggle={logout} autoFocus={false}>
    <LoginForm {...props}>
      {({ usernameField, passwordField, loginButton, ssoButton }) => (
        <>
          <ModalHeader toggle={logout}>Sign In</ModalHeader>
          <ModalBody>
            {usernameField}
            {passwordField}
            {props.error && (
              <div className="alert alert-danger">{props.error}</div>
            )}
            <div className="login-button">{loginButton}</div>
          </ModalBody>
          {ssoButton && (
            <ModalFooter>
              <div className="login-button">{ssoButton}</div>
            </ModalFooter>
          )}
        </>
      )}
    </LoginForm>
  </Modal>
);
